import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlBalancete = '/service/balanceteDespesaRestService/'

class DespesasPorCredorService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
        const adms = config.adms && config.adms.length > 0 ? config.adms.join() : null
        this.state = {
            adms: adms,
        }
    }

    consultar(data) {
        let json = {
            administracao: data.administracao,
            exercicio: data.exercicio,
            mes: data.mes,
            orgaoContabil: data.orgaoContabil,
            unidadeContabil: data.unidadeContabil,
            codigoOrcamentario: data.codigoOrcamentario,
            recursoContabil: data.recursoContabil,
            codigoDestinacao: data.codigoDestinacao,
            identificacao: data.identificacao,
            modelo: data.stnModelo,
            sequencia: data.stnSequencia,
            numeroEmpenho: null,
            codigoRubricaEmpenho: null,
        }

        return this.conex.post(urlBalancete + 'recuperaDespesasPorCredorRest/', JSON.stringify(json))
    }

    consultarIndependente(data) {
        let json = {
            administracao: data.administracao ? data.administracao : this.state.adms,
            exercicio: data.exercicio,
            mes: data.mes,
            orgaoContabil: data.orgaoContabil,
            unidadeContabil: data.unidadeContabil,
            codigoOrcamentario: data.codigoOrcamentario,
            recursoContabil: data.recursoContabil,
            codigoDestinacao: data.codigoDestinacao,
            identificacao: data.identificacao,
            modelo: data.stnModelo,
            sequencia: data.stnSequencia,
            numeroEmpenho: null,
            codigoRubricaEmpenho: null,
        }

        return this.conex.post(urlBalancete + 'recuperaDespesasPorCredorRest/', JSON.stringify(json))
    }
}

export default DespesasPorCredorService
